import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { STRIPE_PAYMENT_LINK, DONATION_AMOUNTS, COLORS } from '../config';

const LS = {
  get: (k, fb) => { try { const v = localStorage.getItem(k); return v ? JSON.parse(v) : fb; } catch { return fb; } },
  set: (k, v)  => { try { localStorage.setItem(k, JSON.stringify(v)); } catch {} },
};

function DonateSection() {
  const [sel, setSel]     = useState(1);
  const [custom, setCustom] = useState('');

  const handleDonate = () => {
    window.open(STRIPE_PAYMENT_LINK, '_blank', 'noopener,noreferrer');
  };

  return (
    <div>
      <p style={{ fontSize:'0.875rem', lineHeight:1.7, color: COLORS.textSecondary, marginBottom:'20px' }}>
        tamizh.fun is free for everyone. No ads, no subscriptions. Your donation supports VIRAT UK's mission to preserve Tamil and Vedic heritage for the UK diaspora.
      </p>
      <div style={{ display:'grid', gridTemplateColumns:'repeat(2,1fr)', gap:'8px', marginBottom:'16px' }}>
        {DONATION_AMOUNTS.map((a,i) => (
          <button key={i} onClick={() => { setSel(i); setCustom(''); }} style={{
            padding:'16px 12px', borderRadius:'12px', cursor:'pointer', textAlign:'center',
            border: sel===i&&!custom ? `2px solid ${COLORS.primary}` : '2px solid transparent',
            background: sel===i&&!custom ? COLORS.primaryLight : COLORS.bgAlt,
            transition:'all 0.2s cubic-bezier(0.16,1,0.3,1)',
          }}>
            <div style={{ fontSize:'1.25rem', fontWeight:800, color: COLORS.primary }}>{a.label}</div>
            <div style={{ fontSize:'0.6875rem', color: COLORS.textMuted, marginTop:'2px' }}>{a.sublabel}</div>
          </button>
        ))}
      </div>
      <div style={{ display:'flex', alignItems:'center', gap:'8px', marginBottom:'16px' }}>
        <span style={{ color: COLORS.textMuted, fontSize:'1.125rem', fontWeight:700 }}>£</span>
        <input value={custom} onChange={e => { setCustom(e.target.value.replace(/\D/g,'')); if(e.target.value) setSel(-1); }}
          placeholder="Custom amount"
          style={{ flex:1, padding:'12px 16px', borderRadius:'10px', border:`1.5px solid ${custom ? COLORS.primary : COLORS.border}`, background: COLORS.bgCard, color: COLORS.textPrimary, fontSize:'1rem', outline:'none' }} />
      </div>
      <button onClick={handleDonate} style={{
        width:'100%', padding:'16px', borderRadius:'12px',
        background: COLORS.primary, border:'none',
        color:'#fff', fontWeight:700, cursor:'pointer', fontSize:'1rem',
        transition:'transform 0.15s cubic-bezier(0.16,1,0.3,1)',
      }}
      onMouseDown={e => e.currentTarget.style.transform='scale(0.98)'}
      onMouseUp={e => e.currentTarget.style.transform='scale(1)'}
      onMouseLeave={e => e.currentTarget.style.transform='scale(1)'}>
        Donate {custom?`£${custom}`:DONATION_AMOUNTS[sel]?.label||''} via Stripe
      </button>
      <div style={{ marginTop:'10px', textAlign:'center', fontSize:'0.6875rem', color: COLORS.textMuted }}>
        Secured by Stripe · VIRAT UK Charity · No account needed
      </div>
    </div>
  );
}

function FeatureSection() {
  const [name, setName]   = useState('');
  const [idea, setIdea]   = useState('');
  const [done, setDone]   = useState(false);
  const [saving, setSaving] = useState(false);
  const [recent, setRecent] = useState([]);

  const loadRecent = async () => {
    try { const r = await window.storage?.get('tz-features-v2', true); setRecent(r ? JSON.parse(r.value).slice(0,5) : []); }
    catch { setRecent([]); }
  };

  useEffect(() => { loadRecent(); }, [done]);

  const submit = async () => {
    if (!idea.trim()) return;
    setSaving(true);
    try {
      const all = recent;
      const updated = [{ name:name||'Anonymous', idea, date:new Date().toLocaleDateString('en-GB') }, ...all].slice(0,50);
      await window.storage?.set('tz-features-v2', JSON.stringify(updated), true);
      // Email via FormSubmit
      try {
        await fetch('https://formsubmit.co/ajax/shri.viratuk@gmail.com', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({
            _subject: 'tamizh.fun — New feature idea',
            name: name || 'Anonymous',
            idea,
            date: new Date().toLocaleDateString('en-GB'),
          }),
        });
      } catch {}
    } catch {}
    setDone(true); setSaving(false); setName(''); setIdea('');
  };

  return (
    <div>
      {done && <div style={{ padding:'12px 16px', borderRadius:'10px', background: COLORS.successLight, marginBottom:'14px', fontSize:'0.8125rem', color: COLORS.success, fontWeight:600 }}>Thanks! The VIRAT UK team will review your idea.</div>}
      <p style={{ fontSize:'0.8125rem', color: COLORS.textSecondary, lineHeight:1.6, marginBottom:'14px' }}>Audio pronunciation? Quiz mode? Telugu support? Tell us what would help your family most.</p>
      <input value={name} onChange={e=>setName(e.target.value)} placeholder="Your name (optional)"
        style={{ width:'100%', padding:'12px 16px', borderRadius:'10px', border:`1.5px solid ${COLORS.border}`, background:'transparent', color: COLORS.textPrimary, fontSize:'0.875rem', outline:'none', boxSizing:'border-box', marginBottom:'10px' }} />
      <textarea value={idea} onChange={e=>setIdea(e.target.value)} rows={4} placeholder="e.g. Add audio so my kids can hear each word"
        style={{ width:'100%', padding:'12px 16px', borderRadius:'10px', border:`1.5px solid ${COLORS.border}`, background:'transparent', color: COLORS.textPrimary, fontSize:'0.875rem', outline:'none', boxSizing:'border-box', resize:'vertical', fontFamily:'inherit', lineHeight:1.6 }} />
      <button onClick={submit} disabled={saving||!idea.trim()} style={{
        marginTop:'10px', padding:'12px 28px', borderRadius:'10px',
        background: idea.trim() ? COLORS.primary : COLORS.border, border:'none',
        color: idea.trim() ? '#fff' : COLORS.textMuted, fontWeight:700, cursor: idea.trim()?'pointer':'default', fontSize:'0.875rem',
        minHeight:'48px',
      }}>{saving?'Saving...':'Submit'}</button>
      {recent.length > 0 && (
        <div style={{ marginTop:'20px' }}>
          <div style={{ fontSize:'0.6875rem', color: COLORS.textMuted, letterSpacing:'0.05em', textTransform:'uppercase', fontWeight:600, marginBottom:'12px' }}>Recent Ideas</div>
          {recent.map((r,i) => (
            <div key={i} style={{ marginBottom:'12px', paddingBottom:'12px', borderBottom: i<recent.length-1 ? `1px solid ${COLORS.border}` : 'none' }}>
              <div style={{ fontSize:'0.8125rem', color: COLORS.textPrimary, lineHeight:1.5 }}>"{r.idea}"</div>
              <div style={{ fontSize:'0.6875rem', color: COLORS.textMuted, marginTop:'4px' }}>{r.name} · {r.date}</div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default function LandingPage() {
  const [tab, setTab] = useState('donate');
  const TABS = [['donate','Donate'],['features','Feature Ideas'],['about','About']];

  return (
    <div style={{ minHeight:'100vh', background: COLORS.bg, color: COLORS.textPrimary }}>

      {/* Hero — left-aligned, clean, no cards */}
      <div style={{ maxWidth:'680px', margin:'0 auto', padding:'clamp(40px,8vw,80px) 20px clamp(32px,6vw,56px)' }}>
        <div style={{ display:'flex', alignItems:'center', gap:'12px', marginBottom:'24px' }}>
          <img
            src={process.env.PUBLIC_URL + '/virat-logo.jpg'}
            alt="VIRAT UK"
            onError={e => { e.target.style.display = 'none'; }}
            style={{ width:'48px', height:'48px', borderRadius:'50%', objectFit:'cover' }}
          />
          <span style={{ fontSize:'0.75rem', fontWeight:600, color: COLORS.textMuted, letterSpacing:'0.05em', textTransform:'uppercase' }}>VIRAT UK · Tamil Learning</span>
        </div>
        <h1 style={{ margin:'0 0 16px', fontSize:'clamp(2rem,6vw,3.5rem)', fontWeight:800, color: COLORS.textPrimary, lineHeight:1.1, letterSpacing:'-0.02em' }}>
          Our Kids Can Speak<br />Our Mother Tongue
        </h1>
        <p style={{ margin:'0 0 32px', maxWidth:'520px', fontSize:'clamp(1rem,2.5vw,1.125rem)', color: COLORS.textSecondary, lineHeight:1.7 }}>
          81 everyday Tamil words that cover 70% of conversation. Whether in London or Chennai, kids today are losing touch with their mother tongue. This free app brings it back, one word at a time. Tamil is where we start, with more languages to follow.
        </p>
        <div style={{ display:'flex', gap:'12px', flexWrap:'wrap' }}>
          <Link to="/app" style={{
            display:'inline-flex', alignItems:'center', justifyContent:'center',
            padding:'14px 32px', borderRadius:'10px',
            background: COLORS.primary, color:'#fff',
            fontWeight:700, fontSize:'1rem', textDecoration:'none', minHeight:'48px',
            transition:'transform 0.15s cubic-bezier(0.16,1,0.3,1)',
          }}>
            Start Learning
          </Link>
          <Link to="/why" style={{
            display:'inline-flex', alignItems:'center', justifyContent:'center',
            padding:'14px 24px', borderRadius:'10px',
            background:'transparent', border:`1.5px solid ${COLORS.border}`,
            color: COLORS.textSecondary, fontWeight:600, fontSize:'1rem', textDecoration:'none', minHeight:'48px',
          }}>
            Why 81 words?
          </Link>
        </div>
      </div>

      {/* Quick proof — not a stats grid, just inline text */}
      <div style={{ borderTop:`1px solid ${COLORS.border}`, borderBottom:`1px solid ${COLORS.border}`, padding:'16px 20px' }}>
        <div style={{ maxWidth:'680px', margin:'0 auto', display:'flex', gap:'24px', flexWrap:'wrap', fontSize:'0.8125rem', color: COLORS.textMuted }}>
          <span><strong style={{ color: COLORS.primary }}>81</strong> top words</span>
          <span><strong style={{ color: COLORS.primary }}>270+</strong> texts analysed</span>
          <span><strong style={{ color: COLORS.primary }}>~70%</strong> of conversation</span>
          <span><strong style={{ color: COLORS.primary }}>Free</strong> forever</span>
          <span><strong style={{ color: COLORS.primary }}>Zero</strong> ads</span>
        </div>
      </div>

      <div style={{ maxWidth:'680px', margin:'0 auto', padding:'40px 20px 64px' }}>

        {/* VIRAT context — not a card, just content */}
        <div style={{ display:'flex', alignItems:'flex-start', gap:'16px', marginBottom:'40px', paddingBottom:'32px', borderBottom:`1px solid ${COLORS.border}` }}>
          <div style={{ flex:1 }}>
            <div style={{ fontSize:'0.875rem', fontWeight:700, color: COLORS.textPrimary, marginBottom:'4px' }}>Supported by VIRAT UK</div>
            <div style={{ fontSize:'0.8125rem', color: COLORS.textMuted, lineHeight:1.6 }}>
              Indian diaspora community charity preserving Vedic and Tamil heritage in the UK.
            </div>
          </div>
          <a href="https://virat.org.uk" target="_blank" rel="noopener noreferrer" style={{
            padding:'8px 16px', borderRadius:'8px', border:`1px solid ${COLORS.border}`,
            color: COLORS.primary, fontSize:'0.75rem', textDecoration:'none', whiteSpace:'nowrap', fontWeight:600,
            flexShrink:0,
          }}>virat.org.uk</a>
        </div>

        {/* Coming soon — subtle, not a card */}
        <div style={{ marginBottom:'40px', paddingBottom:'32px', borderBottom:`1px solid ${COLORS.border}` }}>
          <div style={{ fontSize:'0.6875rem', fontWeight:600, color: COLORS.primary, marginBottom:'8px', letterSpacing:'0.05em', textTransform:'uppercase' }}>Coming Soon</div>
          <div style={{ fontSize:'1.125rem', fontWeight:700, color: COLORS.textPrimary, marginBottom:'8px' }}>AI Text Analyser + More Languages</div>
          <p style={{ fontSize:'0.875rem', color: COLORS.textSecondary, lineHeight:1.7, margin:0 }}>
            Paste any Tamil text and get a frequency-ranked vocabulary profile. <strong style={{color: COLORS.textPrimary}}>Telugu and Kannada</strong> are next. Tamil is our pilot.
          </p>
        </div>

        {/* Phase 2 teaser — Tamil Stories */}
        <div style={{ marginBottom:'40px', paddingBottom:'32px', borderBottom:`1px solid ${COLORS.border}` }}>
          <div style={{ fontSize:'0.6875rem', fontWeight:600, color: COLORS.accent, marginBottom:'8px', letterSpacing:'0.05em', textTransform:'uppercase' }}>Phase 2</div>
          <div style={{ fontSize:'1.125rem', fontWeight:700, color: COLORS.textPrimary, marginBottom:'8px' }}>The Adventures of Kavin, Nila & Mani</div>
          <p style={{ fontSize:'0.875rem', color: COLORS.textSecondary, lineHeight:1.7, margin:0 }}>
            Once kids know their first 81 words, they graduate to illustrated Tamil stories. Follow Kavin, Nila and Mani through manga-style episodes that build reading fluency one chapter at a time. Graded readers that feel like the serial fiction today's kids already love, rooted in Tamil culture. Coming soon as a premium tier to fund the free app.
          </p>
        </div>

        {/* Tabs — underline style instead of pill buttons */}
        <div style={{ display:'flex', gap:'0', borderBottom:`2px solid ${COLORS.border}`, marginBottom:'32px' }}>
          {TABS.map(([t,label]) => (
            <button key={t} onClick={() => setTab(t)} style={{
              padding:'12px 20px', background:'none', border:'none',
              borderBottom: tab===t ? `2px solid ${COLORS.primary}` : '2px solid transparent',
              color: tab===t ? COLORS.primary : COLORS.textMuted,
              fontWeight: tab===t ? 700 : 500, cursor:'pointer', fontSize:'0.875rem',
              marginBottom:'-2px', transition:'color 0.2s',
            }}>{label}</button>
          ))}
        </div>

        {/* Tab content — no wrapping card */}
        <div>
          {tab==='donate'   && <><h3 style={{ margin:'0 0 16px', color: COLORS.textPrimary, fontSize:'1.25rem', fontWeight:700 }}>Support tamizh.fun</h3><DonateSection /></>}
          {tab==='features' && <><h3 style={{ margin:'0 0 16px', color: COLORS.textPrimary, fontSize:'1.25rem', fontWeight:700 }}>What should we build next?</h3><FeatureSection /></>}
          {tab==='about'    && (
            <>
              <h3 style={{ margin:'0 0 16px', color: COLORS.textPrimary, fontSize:'1.25rem', fontWeight:700 }}>About tamizh.fun</h3>
              <p style={{ fontSize:'0.875rem', lineHeight:1.8, color: COLORS.textSecondary, marginBottom:'20px' }}>
                Frequency-ranked Tamil vocabulary for the UK diaspora, built on a corpus of 270+ texts. The spoken/literary split helps bridge home Tamil and classical education, critical for families raising Tamil-speaking children in the UK.
              </p>
              <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:'16px 32px' }}>
                {[['Corpus','270+ Tamil texts'],['Method','Frequency analysis + manual curation'],['Phase 1','Streaks, Flashcards, Quiz, Group codes'],['Phase 2','Telugu, Kannada, cloud sync, teacher dashboard'],['Tech','Pure React, zero backend, localStorage'],['Hosting','IONOS Deploy Now']].map(([k,v]) => (
                  <div key={k}>
                    <div style={{ fontSize:'0.6875rem', color: COLORS.textMuted, fontWeight:600, textTransform:'uppercase', letterSpacing:'0.05em', marginBottom:'2px' }}>{k}</div>
                    <div style={{ fontSize:'0.875rem', color: COLORS.textPrimary }}>{v}</div>
                  </div>
                ))}
              </div>
            </>
          )}
        </div>

        {/* Footer — minimal */}
        <div style={{ marginTop:'64px', paddingTop:'24px', borderTop:`1px solid ${COLORS.border}`, fontSize:'0.75rem', color: COLORS.textMuted }}>
          tamizh.fun · A VIRAT UK initiative · No tracking · No ads
        </div>
      </div>
    </div>
  );
}
